<div class="container-fluid mb-2">
    <div class="row">
        <div class="col-12 mt-2">
            <app-historico-pesquisa></app-historico-pesquisa>
        </div>
        <div class="mt-2"></div>
    </div>
</div>